import P from "components/Typography/P";
import React from "react";
import { useIntl } from "react-intl";

import { LoadingSpinnerSize } from "types/loadingSpinner";
import LoadingSpinner from "components/Loaders/LoadingSpinner";
import { ReactComponent as MagnifyingGlassIcon } from "static/icons/magnifying-glass.svg";
import styles from "./NoRequests.module.scss";

interface NoRequestsProps {
    isLoading: boolean;
}

export const NoRequests: React.FC<NoRequestsProps> = ({ isLoading }) => {
    const intl = useIntl();
    return (
        <div className={styles["no-requests"]}>
            {isLoading ? (
                <LoadingSpinner
                    className={styles["no-requests__loading"]}
                    size={LoadingSpinnerSize.large}
                    relativeCenter
                />
            ) : (
                <MagnifyingGlassIcon className={styles["no-requests__icon"]} />
            )}
            <h2 className={styles["no-requests__title"]}>
                {intl.formatMessage({
                    id: "case_management.no_requests_title",
                })}
            </h2>
            <P className={styles["no-requests__description"]}>
                {intl.formatMessage({
                    id: "case_management.no_requests_description",
                })}
            </P>
        </div>
    );
};
